import React, { forwardRef } from "react";
import { Form } from "react-bootstrap";
import { omit } from "../../utils";

export const IFXFormDownload = (props) => {
  let { formParams, formRef, actionURL, target = "_blank", ..._props } = props;
  return (
    <>
      {formParams && (
        <form
          ref={formRef}
          action={actionURL}
          method="post"
          target={target}
          style={{ display: "none" }}
        >
          {Object.entries(formParams).map(item => {
            return (
              <Form.Control
                type="hidden"
                name={item[0]}
                value={item[1]}
                key={item[0]}
              />
            );
          })}
        </form>
      )}
    </>
  );
};
